import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Home/Testimonials/tables";
import headers from "../../../../Data/Tables/Home/Testimonials/headers";
import { get_all_home_testimonials } from "../../../../Controllers/Home/Testimonials";
import Header from "../../../../Components/Header";
import Loadercomponent from "../../../../Components/Loader";
import Table from "../../../../Components/Table";
import Status from "../../../../Components/Status";
import ActionButton from "../../../../Components/Buttons/action";
import TableImage from "../../../../Components/Tableimage";
import URL from "../../../../Main/url";

const HomeTestimonialsTable = () => {
  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();

  const formdata = (data) => {
    fetchData(data);
  };

  const actiondata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        status: tabledata?.status,
      };

      const features = await get_all_home_testimonials(params);

      if (features?.status) {
        let data = [];

        features?.data?.map((value, index) => {
          data?.push({
            Name: (
              <TableImage
                image={URL + "/uploads" + value?.image}
                name={value?.name}
              />
            ),
            Status: <Status status={value?.status} />,
            Action: (
              <ActionButton
                edit={`/app/home/testimonials/edit/${value?._id}`}
                id={value?._id}
                api="delete-home-testimonial"
                actiondata={actiondata}
              />
            ),
          });
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(features?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header header={headers} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table head={tables} body={body} />
      </Loadercomponent>
    </Header>
  );
};

export default HomeTestimonialsTable;
